import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '业务需求',
    type: 'ISRF_BIZ',
}
